/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import type { PropsWithChildren } from 'react'

import { DonationIdentityCollectorContextProvider } from 'src/features/donation/donation-identity-collector/donation-identity-collector.context'
import { ModalV2ContextProvider } from 'src/features/modal-v2'

import ModalProvider from '../contexts/ModalContext'
import ModalGuideProvider from '../contexts/ModalGuideContext'
import PollProvider from '../contexts/PollProvider'
import QueryProvider from '../contexts/QueryContext'
import ThemeProvider from '../contexts/ThemeContext'
import Web3Provider from '../contexts/Web3Context'

const Providers = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Web3Provider>
      <ThemeProvider>
        <QueryProvider>
          <DonationIdentityCollectorContextProvider>
            <ModalGuideProvider>
              <ModalProvider>
                <ModalV2ContextProvider>
                  <PollProvider>{children}</PollProvider>
                </ModalV2ContextProvider>
              </ModalProvider>
            </ModalGuideProvider>
          </DonationIdentityCollectorContextProvider>
        </QueryProvider>
      </ThemeProvider>
    </Web3Provider>
  )
}

export default Providers
